const sound = {
  on: 'on',
  off: 'off'
};

export default sound;
